var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.legacySignUpCard)?_c('legacy-sign-up-card'):_vm._e(),_vm._v(" "),(_vm.legacySignInCard)?_c('legacy-sign-in-card'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }